/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedShippingInfoLink_viewer$ref = any;
export type PdpSharedDetailShipping_viewer$ref = any;
export type PdpSharedDetailShipping_viewer = {
    readonly relevantShipping: {
        readonly quoteRequestStatus: string | null;
    } | null;
    readonly " $fragmentRefs": PdpSharedShippingInfoLink_viewer$ref;
    readonly " $refType": PdpSharedDetailShipping_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDetailShipping_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "itemId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "relevantShipping",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        }
      ],
      "concreteType": "RelevantShippingInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "quoteRequestStatus",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '799785263ca3ea29b124a6952a40b781';
export default node;
